import { render, staticRenderFns } from "./veSbzcZcCategoryEdit.vue?vue&type=template&id=dee6391e&scoped=true"
import script from "./veSbzcZcCategoryEdit.vue?vue&type=script&lang=js"
export * from "./veSbzcZcCategoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee6391e",
  null
  
)

export default component.exports